import { IRefreshInterval } from '@nkr/views/swap-management/swaps/models';

export const refreshIntervals: IRefreshInterval[] = [
    { value: 0, label: 'Disable' },
    { value: 5, label: '5 seconds' },
    { value: 30, label: '30 seconds' },
    { value: 45, label: '45 seconds' },
    { value: 60, label: '60 seconds' }
];